const productsData5 = [
  {id: 0, category:'Rotating Unions', type:'Special Applications', size: '1/8\" - 1\"', series: '1005\, 468\, 981', description: 'Water\, Oil Rig\, Clutch & Brake', passages: '1 to 3', detail: 'View',img1:'model_1005',img2:'model_468',img3:'model_981',img4:''},
  {id: 1, category:'Rotating Unions', type:'Special Applications',size: '1/4\" - 3/8\"', series: '1102\, 1115\, 882', description: 'Central Tire Inflation', passages: '1 or 2', detail: 'View',img1:'model_1102',img2:'',img3:'',img4:''},
  {id: 2, category:'Rotating Unions', type:'Special Applications',size: '3/8\"', series: '7000 / 7100', description: 'Around The Shaft', passages: '', detail: 'View',img1:'model_7000',img2:'',img3:'',img4:''}
  
]

export default productsData5
